module.exports = __webpack_public_path__ + "static/una-f7d9d8b9a454198ad3c7eb3bf9e824f3.jpg";